import { useContext } from "react";
import { Self360StoreContext } from "../components";

export function useSelf360Store() {
  const store = useContext(Self360StoreContext);

  return store;
}
